import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'success' | 'neutral';
  className?: string;
}
export function Badge({
  children,
  variant = 'neutral',
  className = ''
}: BadgeProps) {
  const variants = {
    primary: 'bg-primary-50 text-primary-700 border-primary-100',
    success: 'bg-green-50 text-green-700 border-green-100',
    neutral: 'bg-slate-100 text-slate-700 border-slate-200'
  };
  return <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${variants[variant]} ${className}`} data-id="element-313">
      {children}
    </span>;
}